import React from 'react';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid, Button} from '@mui/material'
import {IncoTermService} from '../../../services';
import CustomDataGrid from '../../../customUtil/DataGrid';
const columns = [
    {
        field: 'termCode', headerName: 'Term Code', width: 230,
        renderCell: (params) =>
            (<Link style={{textDecoration: 'none'}} component={RouterLink} to={'/references/inco-term/' + params.row.id}>
                {params.value}
            </Link>)
    },
    {field: 'description', headerName: 'Description', width: 230},
    {field: 'forVendor', headerName: 'For Vendor', width: 230},
    {field: 'forClient', headerName: 'For Client', width: 230}
   
]

const IncoTerms = () => {
        const [list, setList] = React.useState([]);
        const history = useHistory();

        React.useEffect(() => {
            IncoTermService.getAll()
                .then((response) => setList(response.data));
        }, []);

        return (
            <React.Fragment>
                <Container>
                    <header>
                        <h1>Incoterms</h1>
                    </header>
                    <Grid container spacing={5}>
                 
                        <Grid item xs={12}>
                        <Button variant='contained' color='primary' onClick={() => {history.push('/references/inco-term/new')}}>Create New</Button>
                        </Grid>    
                        <Grid item xs={12}>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                              />                        
                      
                        </Grid>
                    </Grid>
                </Container>
            </React.Fragment>
        );
    }
;

export default IncoTerms;
